import './styles.css';
import { render } from 'preact';
import { startClock } from './engine/clock';
import { loadGame, saveGame } from './engine/save';
import { createInitialState } from './engine/state';
import { getState, setState, update } from './engine/store';
import { applyOffline, tick } from './game/sim';
import { App } from './ui/App';

const SAVE_INTERVAL_MS = 10_000;

const now = Date.now();
const saved = loadGame();
const state = saved ?? createInitialState(now);
if (saved) applyOffline(state, now);
setState(state);

startClock(() => update((s) => tick(s, Date.now())));

setInterval(() => saveGame(getState()), SAVE_INTERVAL_MS);
window.addEventListener('pagehide', () => saveGame(getState()));
document.addEventListener('visibilitychange', () => {
  if (document.hidden) saveGame(getState());
});

const root = document.getElementById('app');
if (root) render(<App />, root);
